import {
  ColorInput as MantineColorInput,
  ColorInputProps,
} from '@mantine/core';

export type IColorInputProps = ColorInputProps;

/** @registry Design-layer pass-through over Mantine ColorInput; import this instead of @mantine/core ColorInput outside src/design. Extend here when ColorInput needs house behavior. */
export const ColorInput = MantineColorInput;
